import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { applyContainerQuery } from 'react-container-query';

import Carousel from '../Carousel';
import containerQuery from '../../constants/containerQuery';
import containerQueryProps from '../../props/containerQueryProps';
import EventDetailsSummary from '../EventDetailsSummary';
import EventShape from '../types/eventShape';

import './EventDetailsHeader.scss';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { EVENT_IMAGE } from '../Carousel/constants';

const EventDetailsHeader = (props) => {
  const {
    city,
    containerQuery: {
      sm, lg, xl, xxl,
    },
    context,
    event,
    isOnline,
    locationSlug,
    showBookNowBtn,
    tableConfigId,
    venueSlug,
    isMobile,
  } = props;

  const {
    slides,
  } = event;

  return (
    <div className="EventDetailsHeader">
      <div className={cx('EventDetailsHeader__container', {
        'EventDetailsHeader__container--stacked': !lg,
        'EventDetailsHeader__container--desktop': lg,
        'EventDetailsHeader__container--lg': lg,
        'EventDetailsHeader__container--xl': xl,
        'EventDetailsHeader__container--xxl': xxl,
      })}
      >
        <div className="EventDetailsHeader__carousel-wrapper">
          <Carousel
            buttonPosition="bottom-right-connected"
            carouselId="event-images"
            hasButtons={lg}
            hasDotGroup={lg}
            infinite={false}
            isMobile={isMobile}
            slideContent={slides}
            slideType={EVENT_IMAGE}
            step={1}
            visibleSlides={1}
          />
        </div>

        <div className="EventDetailsHeader__summary-container">
          <EventDetailsSummary
            city={city}
            context={context}
            event={event}
            isOnline={isOnline}
            locationSlug={locationSlug}
            neighborhood={event?.location?.neighborhood}
            showBookNowBtn={!sm && showBookNowBtn}
            slideContent={slides}
            tableConfigId={tableConfigId}
            venueSlug={venueSlug}
          />
        </div>
      </div>
    </div>
  );
};

EventDetailsHeader.propTypes = {
  city: PropTypes.string,
  containerQuery: containerQueryProps,
  context: PropTypes.oneOf(['widget', 'consumer']),
  event: EventShape.isRequired,
  isOnline: PropTypes.bool,
  locationSlug: PropTypes.string,
  showBookNowBtn: PropTypes.bool,
  tableConfigId: PropTypes.string,
  venueSlug: PropTypes.string,
  isMobile: PropTypes.bool,
};

EventDetailsHeader.defaultProps = {
  city: undefined,
  containerQuery: {},
  context: 'consumer',
  isOnline: false,
  locationSlug: undefined,
  showBookNowBtn: true,
  tableConfigId: undefined,
  venueSlug: undefined,
  isMobile: false,
};

EventDetailsHeader.displayName = 'EventDetailsHeader';
export { EventDetailsHeader as Component };
export default applyContainerQuery(EventDetailsHeader, containerQuery);
